import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "relative" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.action_items.new')
};
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import SkeletonActionItem from '@/components/action_items/SkeletonActionItem.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'NewActionItemCard',
    setup(__props) {
        const retroStore = useRetroStore();
        const { isActionItemWritingIdle } = storeToRefs(retroStore);
        const { startWritingActionItem } = retroStore;
        return (_ctx, _cache) => {
            const _component_pill_button = _resolveComponent("pill-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SkeletonActionItem),
                (_unref(isActionItemWritingIdle))
                    ? (_openBlock(), _createBlock(_component_pill_button, {
                        key: 0,
                        class: "absolute absolute-center",
                        onClick: _unref(startWritingActionItem)
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('title')), 1)
                        ], undefined, true),
                        _: 1
                    }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
